const DEVICE_KEY = 'driftglass.v1.deviceKey';

function randomBase64Url(bytes = 24): string {
  const arr = new Uint8Array(bytes);
  crypto.getRandomValues(arr);
  let bin = '';
  arr.forEach((b) => { bin += String.fromCharCode(b); });
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function getDeviceKey(): string {
  const existing = localStorage.getItem(DEVICE_KEY);
  if (existing) return existing;
  const key = `dg_${randomBase64Url(32)}`;
  localStorage.setItem(DEVICE_KEY, key);
  return key;
}

export function resetDeviceKey(): string {
  localStorage.removeItem(DEVICE_KEY);
  return getDeviceKey();
}
